import {gsap} from "gsap";
import {HOTBGameData} from "../server/HOTBData";
import {HOTB} from "../HOTB";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {ISymbol} from "../../core/reel/IReelData";
import {GameAssets} from "../GameAssets";
import {GameConfig} from "../GameConfig";
import {ReelView} from "../reels/ReelView";

export class EachSymWinView extends PIXI.Container {
    constructor() {
        super();
        this.name = "EachSymWinView";
        this.init();
    }

    public showWinAndWays(durr: number): gsap.core.Timeline {
        const winPosArray: number[][] = [],
            gameData: HOTBGameData = HOTB.model.gameData,
            tl: gsap.core.Timeline = gsap.timeline({
                onComplete: (): void => {
                    this.removeChildren();
                }
            });

        let delayOffset: number = 0.2;

        for (let i: number = 0; i < gameData.betWayWins.length; i++) {
            const winData: IBetWayWinData = gameData.betWayWins[i],
                winWrapper: PIXI.Container = this.createBetWinView(winData),
                reelId: number = (winData.length - 1),
                currPosArray: number[] = [reelId, winData.reelWinPositions[reelId].lastIndexOf(true)],
                isAtSameSymbol: boolean = winPosArray.some(innerArray =>
                    innerArray.length === currPosArray.length && innerArray.every((value, index) => value === currPosArray[index])
                );

            if (isAtSameSymbol) {
                delayOffset += 0.25;
            } else {
                delayOffset = 0;
            }

            winPosArray[i] = currPosArray;

            this.addChild(winWrapper);

            tl.add((): void => {
                winWrapper.alpha = 1;
            }, delayOffset);

            tl.to(winWrapper, {y: winWrapper.position.y - 90, duration: durr}, delayOffset);

            tl.to(winWrapper, {
                alpha: 0,
                duration: durr - (durr / 1.5)
            }, (delayOffset + (durr / 1.5)));
        }

        return tl;
    }

    private init(): void {
        this.position.set(160, 270);
    }

    private createBetWinView(winData: IBetWayWinData): PIXI.Container {
        const wrapper: PIXI.Container = new PIXI.Container(),
            countUp: BasicBitmapCountUp = this.createCountUp(winData.multipliedAmount),
            waysContainer: PIXI.Container = this.createWaysText(winData.numberOfCombinations),
            reelId: number = (winData.length - 1),
            symId: number = winData.reelWinPositions[reelId].lastIndexOf(true),
            currReelView: ReelView = HOTB.reelArea.mainReelModels[reelId].reelView,
            lastWinSym: ISymbol = currReelView.getSymbol(symId);

        wrapper.name = winData.symbol;
        wrapper.alpha = 0;
        wrapper.position.set(currReelView.position.x, lastWinSym.position.y);
        wrapper.addChild(countUp, waysContainer);

        return wrapper;
    }

    private createCountUp(amount: number): BasicBitmapCountUp {
        const countUp: BasicBitmapCountUp = new BasicBitmapCountUp({
            fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 7,
        }, GameConfig.symbolWidth, new PIXI.Point(0.5, 0.5));

        countUp.getCountAnimation(amount, amount, 0.001);
        countUp.position.set(0, 0);

        return countUp;
    }

    private createWaysText(waysCount: number): PIXI.Container {
        const waysContainer: PIXI.Container = new PIXI.Container(),
            textName: string = HOTB.apiPlugin.translations.translate(waysCount > 1 ? "Ways" : "Way"),
            waysWonText: PIXI.Text = new PIXI.Text(waysCount + " " + textName, {
                fontName: "OpenSans-Bold",
                fontSize: 21.5,
                fill: "#ffcd60",
                fontWeight: "bold",
                dropShadow: true,
                dropShadowColor: "#000000",
                dropShadowBlur: 2,
                dropShadowDistance: 2,
                dropShadowAngle: Math.PI / 5,
                strokeColor: "#000000",
                strokeThickness: 2,
            });

        waysWonText.anchor.set(0.5, 0);
        waysWonText.y = 17;

        if (waysWonText.width > GameConfig.symbolWidth) {
            waysContainer.scale.set(GameConfig.symbolWidth / waysWonText.width);
        }

        waysContainer.addChild(waysWonText);

        return waysContainer;
    }
}